import { useCallback } from 'react';
import { useIsPreviewMode } from '@stores/AppCommonData';
import getUrl from '@utils/api-helper/getUrl';
import { readCookie } from '@utils/cookies';

const useWorkerAPIHandler = () => {
  const nextPreviewMode = useIsPreviewMode();

  const getUrlAndAllHeaders = useCallback(
    ({ endpoint, hostType, params }) => {
      const url = getUrl({ endpoint, params, hostType, nextPreviewMode });
      const accessToken = readCookie('accessToken');
      return {
        url,
        tokens: { accessToken }
      };
    },
    [nextPreviewMode]
  );

  return {
    getUrlAndAllHeaders
  };
};

export default useWorkerAPIHandler;
